/**
 * @generated SignedSource<<fb4e4e780615216cf58410f7c24eb50e>>
 * @relayHash 66c043e29cccf50b25224cf5a78d476a
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/579.0.0-2026-10-05T13:12:24.918Z/PdpSharedOriginalLanguageProviderQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedOriginalLanguageProviderQuery$variables = {
  itemId: string;
};
export type PdpSharedOriginalLanguageProviderQuery$data = {
  readonly viewer: {
    readonly item: {
      readonly attributes: {
        readonly " $fragmentSpreads": FragmentRefs<"getAttributeInfo_itemAttributes">;
      } | null;
      readonly description: string | null;
      readonly pdpDetailsDisplay: ReadonlyArray<{
        readonly detailKey: string | null;
        readonly detailValues: ReadonlyArray<{
          readonly detailKey: string | null;
          readonly displayDetails: string | null;
          readonly displayName: string | null;
        } | null> | null;
      } | null> | null;
      readonly seoDescription: string | null;
      readonly title: string | null;
    } | null;
  };
};
export type PdpSharedOriginalLanguageProviderQuery = {
  response: PdpSharedOriginalLanguageProviderQuery$data;
  variables: PdpSharedOriginalLanguageProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itemId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seoDescription",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailKey",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayDetails",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": [
    (v8/*:: as any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": [
    (v8/*:: as any*/),
    (v11/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PdpSharedOriginalLanguageProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "Item",
            "kind": "LinkedField",
            "name": "item",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PdpDetail",
                "kind": "LinkedField",
                "name": "pdpDetailsDisplay",
                "plural": true,
                "selections": [
                  (v5/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "detailValues",
                    "plural": true,
                    "selections": [
                      (v5/*:: as any*/),
                      (v6/*:: as any*/),
                      (v7/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ItemAttributes",
                "kind": "LinkedField",
                "name": "attributes",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "getAttributeInfo_itemAttributes",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "kind": "LinkedField",
                        "name": "customizable",
                        "plural": true,
                        "selections": [
                          (v9/*:: as any*/),
                          (v10/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "kind": "LinkedField",
                        "name": "ringResizable",
                        "plural": true,
                        "selections": [
                          (v9/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "PdpSharedOriginalLanguageProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "Item",
            "kind": "LinkedField",
            "name": "item",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PdpDetail",
                "kind": "LinkedField",
                "name": "pdpDetailsDisplay",
                "plural": true,
                "selections": [
                  (v5/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "detailValues",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v5/*:: as any*/),
                      (v6/*:: as any*/),
                      (v7/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ItemAttributes",
                "kind": "LinkedField",
                "name": "attributes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AttributeValue",
                    "kind": "LinkedField",
                    "name": "customizable",
                    "plural": true,
                    "selections": [
                      (v12/*:: as any*/),
                      (v10/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AttributeValue",
                    "kind": "LinkedField",
                    "name": "ringResizable",
                    "plural": true,
                    "selections": [
                      (v12/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*:: as any*/)
                ],
                "storageKey": null
              },
              (v11/*:: as any*/)
            ],
            "storageKey": null
          },
          (v11/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/579.0.0-2026-10-05T13:12:24.918Z/PdpSharedOriginalLanguageProviderQuery",
    "metadata": {},
    "name": "PdpSharedOriginalLanguageProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3c433cf379f360a40d741e4c4752e1ea";

export default node;
